import classnames from 'classnames'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import * as stripeConnectActions from '../../../actions/stripeConnectActions'
import LoadingSpinner from '../../common/loader/legacy-loaders/LoadingSpinner'

import classes from './ConnectStripeRefreshPage.module.scss'

const ConnectStripeRefreshPage = () => {
  const { t } = useTranslation()

  useEffect(() => {
    refreshStripe()
  }, [])

  const refreshStripe = () => {
    stripeConnectActions.refreshConnectToStripe()
      .then((res) => window.location.replace(res.data.account_link_url))
      .catch((err) => console.log('Something went wrong: ', err))
  }

  return (
    <LoadingSpinner
      text={t('communitySettings.pricing.stripeRefresh.message')}
      classNames={{
        wrapper: 'h-100',
        spinner: classnames('fa-4x', classes.spinner),
      }}
    />
  )
}

export default ConnectStripeRefreshPage
